/**
 * Enforce mousewheel to trigger horizontal scroll
 * Attention: Does not work with CSS scroll snapping
 *
 * @param {import('alpinejs').default} Alpine
 */
export default Alpine => {
  Alpine.directive('horizontal-wheel', (el, {}, { cleanup }) => {
    /**
     * @param {WheelEvent} event
     */
    function handler(event) {
      if (event.deltaY === 0 || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return

      event.preventDefault()

      let element = event.currentTarget

      let scrollLeft = element.scrollLeft
      let scrollWidth = element.scrollWidth
      let clientWidth = element.clientWidth
      let scrollDelta = event.deltaY

      if (scrollLeft + scrollDelta < 0) {
        element.scrollTo(0, 0)
      } else if (scrollLeft + scrollDelta > scrollWidth - clientWidth) {
        element.scrollTo(scrollWidth - clientWidth, 0)
      } else {
        element.scrollTo(element.scrollLeft + scrollDelta, 0)
      }
    }

    // Only use wheel listener on hovering devices
    let matcher = matchMedia('(hover: hover)')

    if (matcher.matches) {
      el.addEventListener('wheel', handler)
    }

    let matcherHandler = () => {
      if (matcher.matches) {
        el.addEventListener('wheel', handler)
      } else {
        el.removeEventListener('wheel', handler)
      }
    }

    matcher.addListener(matcherHandler)

    cleanup(() => {
      el.removeEventListener('wheel', handler)
      matcher.removeListener(matcherHandler)
    })
  })
}
